(() => {
  const STORAGE_KEY = 'aurea-color-mode';
  const root = document.documentElement;
  const systemDark = window.matchMedia('(prefers-color-scheme: dark)');

  /**
   * Get the current mode.
   * If the visitor has never chosen a mode,
   * use their device preference.
   *
   * @returns {'light' | 'dark'}
   */
  const getMode = () => {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (stored === 'light' || stored === 'dark') {
      return stored;
    }

    return systemDark.matches ? 'dark' : 'light';
  };

  /**
   * @param {'light' | 'dark'} mode
   */
  const applyMode = (mode) => {
    root.dataset.colorMode = mode;
    root.dataset.theme = mode;
    root.style.colorScheme = mode;

    document.querySelectorAll('[data-aurea-theme-toggle]').forEach((button) => {
      const nextMode = mode === 'dark' ? 'light' : 'dark';

      button.setAttribute(
        'aria-label',
        `Switch to ${nextMode} mode`
      );

      button.setAttribute(
        'title',
        `Switch to ${nextMode} mode`
      );
    });
  };

  /**
   * @param {'light' | 'dark'} mode
   */
  const setMode = (mode) => {
    localStorage.setItem(STORAGE_KEY, mode);
    applyMode(mode);
  };

  const toggleMode = () => {
    const current = getMode();
    setMode(current === 'dark' ? 'light' : 'dark');
  };

  applyMode(getMode());

  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    const button = target.closest('[data-aurea-theme-toggle]');

    if (button) {
      toggleMode();
    }
  });

  systemDark.addEventListener('change', () => {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (stored !== 'light' && stored !== 'dark') {
      applyMode(systemDark.matches ? 'dark' : 'light');
    }
  });
})();